<template>
  <div class="Brochure">
    <swiper :options="swiperOptions" style="width:100vw;height: 100vh;">
      <swiper-slide
        class="swiper-slide swiper-slide1"
        style="width: 100vw;height: 100vh;background:red"
      >
        Slide 1
      </swiper-slide>
      <swiper-slide
        class="swiper-slide swiper-slide2"
        style="width: 100vw;height: 100vh;background:red"
      >
        Slide 2
      </swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide3">Slide 3</swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide4">Slide 4</swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide5">Slide 5</swiper-slide>
    </swiper>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper";
let bgurl = "./static/images/Brochure/bg/";
let BrochureUrl = "./static/images/Brochure/";
export default {
  data() {
    let that = this;
    return {
      //初始化swiper
      swiperOptions: {
        direction: "vertical",
        initialSlide: 0
      }
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      let _that = this;
      this.$nextTick(() => {
        this.swiper = new Swiper(".BrochureSwiper", {
          pagination: {
            el: ".swiper-pagination"
          },
          on: {
            slideChangeTransitionStart: function() {
              //    _that.navlenth(this.activeIndex)
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-media-controls {
  display: none !important;
}
.Brochure {
  width: 100vw;
  height: 100vh;
  background: #fff;

  .myslide {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    .bg {
      width: 100vw;
      height: auto;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Aerial.vue